/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_IVA_PLAZO_ITEM = {
  id: 'iva_plazo',
  screenId: 'tax-iva-plazo',
  label: 'Plazo',
  description: 'Extensiones de vencimiento de la DDJJ de IVA.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás períodos en los que AFIP extendió el vencimiento de la presentación de IVA (feriados, resoluciones). El sistema usa esa fecha al calcular vencimientos.',
      },
      {
        title: 'Paso 1 — Ver el listado',
        bullets: [
          'Interruptor «Solo activas».',
          'Columnas: Período desde, Período hasta, Vence extensión, Activo.',
          'Tocá una fila para editar. Botón + para nueva extensión.',
        ],
      },
      {
        title: 'Paso 2 — Alta / edición',
        fields: [
          { label: 'Período desde / hasta', description: 'Rango del período fiscal al que aplica la extensión.' },
          { label: 'Vence extensión', description: 'Nueva fecha límite de presentación/pago.' },
          { label: 'Activo', description: 'Desactivá extensiones que ya no correspondan.' },
        ],
      },
    ],
  },
}
